export default __webpack_public_path__ + "static/media/grandi-lastre.9027af19.jpg";